import { useCallback } from 'react';
import { useSteps } from '../lib';
import { StepsHandlers } from './interfaces';

interface Returned {
    pushAllowedStep: (stepNumber: number) => void;
    removeAllowedStep: (stepNumber: number) => void;
    handlers: StepsHandlers;
}

export function useStepsPublic(): Returned {
    const { setAllowedSteps, setStepNumber, setErrorSteps, setWarningSteps } = useSteps();

    const pushAllowedStep = useCallback(
        (stepNumber: number) => {
            setAllowedSteps((prev) => {
                if (!~prev.indexOf(stepNumber)) return [...prev, stepNumber];
                return prev;
            });
        },
        [setAllowedSteps],
    );

    const removeAllowedStep = useCallback(
        (stepNumber: number) => {
            setAllowedSteps((prev) => prev.filter((sn) => sn !== stepNumber));
        },
        [setAllowedSteps],
    );

    return {
        pushAllowedStep,
        removeAllowedStep,
        handlers: {
            setAllowedSteps,
            setStepNumber,
            setErrorSteps,
            setWarningSteps,
        },
    };
}
